import { apolloClient } from "@/entities/graphql";
import { captureException } from "@sentry/react";
import {
  ClientSettingsDocument,
  ClientSettingsQuery,
  Feature,
  PublicConfigDocument,
  PublicConfigQuery,
  PublicConfigQueryVariables,
} from "../../generated/apollo";

let clientSettings: ClientSettingsQuery | null = null;
export function initAppConfig() {
  return Promise.all([
    apolloClient
      .query<ClientSettingsQuery>({ query: ClientSettingsDocument })
      .then((resp) => {
        clientSettings = resp.data;
        return resp;
      })
      // we need to ignore this error for initial app start when user does not belong to any client
      .catch((e) => {
        console.error(e);
        captureException(e);
      }),
    apolloClient.query<PublicConfigQuery>({ query: PublicConfigDocument }),
  ]);
}

export function getAppConfig() {
  const config = apolloClient.readQuery<
    PublicConfigQuery,
    PublicConfigQueryVariables
  >({ query: PublicConfigDocument });

  if (!config) {
    throw new Error("Failed to get public config");
  }

  if (!clientSettings) {
    throw new Error("Failed to get client settings");
  }

  const features = (clientSettings.currentClient.clientFeatures || []).reduce(
    (acc, next) => ((acc[next.name] = true), acc),
    {} as Record<Feature, boolean | undefined>,
  );

  const {
    __typename,
    features: _publicFeatures,
    ...rest
  } = config.configPublicInfo;

  return {
    ...rest,
    features,
  };
}
